<div class="not-found-container">
  <div class="not-found-content">
    <div class="error-code">404</div>
    <h1>Page Not Found</h1>
    <p>The page you are looking for doesn't exist or has been moved.</p>
    <div class="actions">
      <a routerLink="/" class="home-button">Go to Homepage</a>
    </div>
  </div>
</div>